// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IClaimActivityMultiEmployersSummaryRecordDto } from './IClaimActivityMultiEmployersSummaryRecordDto';
import {
    IClaimActivityMultiEmployersSummaryRecordDtoFromJSON,
    IClaimActivityMultiEmployersSummaryRecordDtoFromJSONTyped,
    IClaimActivityMultiEmployersSummaryRecordDtoToJSON,
    IClaimActivityMultiEmployersSummaryRecordDtoToJSONTyped,
} from './IClaimActivityMultiEmployersSummaryRecordDto';

/**
 * 
 * @export
 * @interface IReportSummaryGroupDtoClaimActivityMultiEmployersSummaryRecordDto
 */
export interface IReportSummaryGroupDtoClaimActivityMultiEmployersSummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IReportSummaryGroupDtoClaimActivityMultiEmployersSummaryRecordDto
     */
    subsidiary_name?: string;
    /**
     * 
     * @type {Array<IClaimActivityMultiEmployersSummaryRecordDto>}
     * @memberof IReportSummaryGroupDtoClaimActivityMultiEmployersSummaryRecordDto
     */
    subsidiary_records?: Array<IClaimActivityMultiEmployersSummaryRecordDto>;
}

/**
 * Check if a given object implements the IReportSummaryGroupDtoClaimActivityMultiEmployersSummaryRecordDto interface.
 */
export function instanceOfIReportSummaryGroupDtoClaimActivityMultiEmployersSummaryRecordDto(value: object): value is IReportSummaryGroupDtoClaimActivityMultiEmployersSummaryRecordDto {
    return true;
}

export function IReportSummaryGroupDtoClaimActivityMultiEmployersSummaryRecordDtoFromJSON(json: any): IReportSummaryGroupDtoClaimActivityMultiEmployersSummaryRecordDto {
    return IReportSummaryGroupDtoClaimActivityMultiEmployersSummaryRecordDtoFromJSONTyped(json, false);
}

export function IReportSummaryGroupDtoClaimActivityMultiEmployersSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportSummaryGroupDtoClaimActivityMultiEmployersSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'subsidiary_name': json['subsidiary_name'] == null ? undefined : json['subsidiary_name'],
        'subsidiary_records': json['subsidiary_records'] == null ? undefined : ((json['subsidiary_records'] as Array<any>).map(IClaimActivityMultiEmployersSummaryRecordDtoFromJSON)),
    };
}

export function IReportSummaryGroupDtoClaimActivityMultiEmployersSummaryRecordDtoToJSON(json: any): IReportSummaryGroupDtoClaimActivityMultiEmployersSummaryRecordDto {
    return IReportSummaryGroupDtoClaimActivityMultiEmployersSummaryRecordDtoToJSONTyped(json, false);
}

export function IReportSummaryGroupDtoClaimActivityMultiEmployersSummaryRecordDtoToJSONTyped(value?: IReportSummaryGroupDtoClaimActivityMultiEmployersSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subsidiary_name': value['subsidiary_name'],
        'subsidiary_records': value['subsidiary_records'] == null ? undefined : ((value['subsidiary_records'] as Array<any>).map(IClaimActivityMultiEmployersSummaryRecordDtoToJSON)),
    };
}

